export default "__VITE_ASSET__DtLYp5mD__"